import { IS_APP, PROD_URLS, TEST_REPORT_URL, PROD_REPORT_URL, PAGES } from './const';
import Utils from '@/utils/utils';
import set from 'lodash-es/set';

// 获上报地址
export function getReportUrl() {
  let url = TEST_REPORT_URL;
  if (IS_APP) {
    url = PROD_REPORT_URL;
  } else {
    const host = location.host;
    if (PROD_URLS.includes(host)) {
      url = PROD_REPORT_URL;
    }
  }
  return url;
}

// 获页面标题
export function getNavigationBarTitle(url) {
  const route = url.split('?')[0].replace(/^\/+/, '');
  if (route === 'pages/index/iframeWeb') {
    return 'webview';
  }
  // 从 pages 文件中找到匹配的路径
  const page = PAGES.find((page) => page.path === route);
  return Utils.get(page, 'style.navigationBarTitleText', '');
}

// 获当前路由
export function getCurrentRoute() {
  const pages = getCurrentPages();
  const currentPage = pages[pages.length - 1];
  return currentPage ? `/${currentPage.route}` : '';
}

// 生成唯一请求 ID
export function generateUniqueRequestId() {
  return `request_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

// 开始计时
export function startTiming(path) {
  const globalData = getApp().globalData;
  const route = path.split('?')[0];
  const loaded = Utils.get(globalData, `pageLoad.['${route}'].loaded`, false);
  if (!loaded) {
    set(getApp().globalData, `pageLoad.['${route}'].start`, new Date().getTime());
  }
}

// 结束计时
export function endTiming(path) {
  let page_load_time = 0;
  const globalData = getApp().globalData;
  const route = path.split('?')[0];
  const loaded = Utils.get(globalData, `pageLoad.['${route}'].loaded`, false);
  const start = Utils.get(globalData, `pageLoad.['${route}'].start`, 0);
  if (!loaded && start > 0) {
    const now = new Date().getTime();
    page_load_time = now - start;
    set(getApp().globalData, `pageLoad.['${route}'].loaded`, true);
    set(getApp().globalData, `pageLoad.['${route}'].end`, now);
    set(getApp().globalData, `pageLoad.['${route}'].page_load_time`, page_load_time);
  }
  // console.log('pageLoad', getApp().globalData.pageLoad);
  return page_load_time;
}
